import React from 'react';

/** One pill per operation — staff count + repeat-low badge. */
export const OperationTabs = ({ ops, active, onPick }) => (
  <div className="flex gap-2 overflow-x-auto pb-1 mb-4" data-testid="rank-op-tabs">
    {ops.map((o) => {
      const on = o.code === active;
      return (
        <button key={o.code} type="button" onClick={() => onPick(o.code)} data-testid={`rank-op-tab-${o.code}`}
          className={`shrink-0 inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors ${on ? 'bg-gray-900 text-white border-gray-900' : 'bg-white text-gray-700 border-gray-300 hover:border-gray-500'}`}>
          <span>{o.name}</span>
          <span className={`text-xs ${on ? 'text-gray-300' : 'text-gray-400'}`}>{o.module}</span>
          <span className={`rounded-full px-1.5 text-xs tabular-nums ${on ? 'bg-white/15' : 'bg-gray-100'}`}>{o.staff}</span>
          {o.repeat_low > 0 && <span className="rounded-full bg-rose-600 text-white px-1.5 text-xs tabular-nums" title="Repeat low performers">{o.repeat_low}</span>}
        </button>
      );
    })}
  </div>
);

export default OperationTabs;
